import brochureCatalogue from '../assets/doc/Aavjo Brochure (4).pdf';
import brochureProducts from '../assets/doc/Aavjo Brochure (2) (4).pdf';
import brochureBrand from '../assets/doc/Aavjo Brand Template.pdf';

export const brochures = [
  {
    id: 'catalogue',
    label: 'Product Catalogue',
    file: brochureCatalogue,
    downloadName: 'Aavjo-Product-Catalogue.pdf',
  },
  {
    id: 'brochure',
    label: 'Company Brochure',
    file: brochureProducts,
    downloadName: 'Aavjo-Company-Brochure.pdf',
  },
  {
    id: 'brand',
    label: 'Brand Brochure',
    file: brochureBrand,
    downloadName: 'Aavjo-Brand-Brochure.pdf',
  },
];
